const reqEnum = {
    loading: 'LOADING',
    fullfilled: 'FULLFILLED',
    rejected: 'REJECTED',
};

export default reqEnum;